export const SET_KANBAN_STAGES_UI_FLAG = 'SET_KANBAN_STAGES_UI_FLAG';
export const SET_KANBAN_STAGES = 'SET_KANBAN_STAGES';
export const ADD_KANBAN_STAGE = 'ADD_KANBAN_STAGE';
export const EDIT_KANBAN_STAGE = 'EDIT_KANBAN_STAGE';
export const DELETE_KANBAN_STAGE = 'DELETE_KANBAN_STAGE';
